<template>
  <div>
    <div class="panel-heading">
      <h4 class="panel-title">Invoices</h4>
    </div>

    <div class="panel-body" style="display: block;">
      <div class="row">
        <preDatatableComponent
          :removeAddButton="true"
          :removeWarehouseDeliverButton="true"
          :tableData="tableData"
          :resetGetResults="resetGetResults"
          :resetGetResults2="resetGetResults2"
          :searchMe="searchMe"
          :pagination="pagination"
          :perPageFix="perPageFix"
          :filterTable="filterTable"
          :hideSelectingColumn="true"
        ></preDatatableComponent>
        <div class="col-xs-12">
          <div class="row text-center">
            <span id="test-editable" style="opacity:0"></span>
          </div>
          <datatable
            v-if="!isMobile"
            :sortDir="tableData.sortDir"
            :columns="columns"
            :sortByColumn="sortByColumn"
            :searchOneCol="searchOneCol"
            :sortKey="sortKey"
            :sortOrders="sortOrders"
          >
            <tbody>
              <tr v-for="r in apiResults" :key="r.credit_log_transaction_id">
                <td v-if="r.is_open === '0'">
                  <div class="media-left">
                    {{ r.theOrderID }}
                    <span class="status-mark bg-danger-600 media-badge"></span>
                  </div>
                </td>
                <td v-else>{{ r.theOrderID }}</td>
                <td>{{ r.invoice_number }}</td>
                <td>
                  <a :href="r.product_url" target="_blank">{{
                    r.product_url.replace(/http(s)?:\/\//, '').substr(0, 25) +
                      (r.product_url.length > 25 ? '...' : '')
                  }}</a>
                </td>
                <td>{{ r.product_name }}</td>
                <td>
                  <span v-if="r.description.includes('Subtract')">-</span>
                  <span v-else>+</span>
                  ${{ r.amount }}
                </td>
                <td v-if="r.credit_log_transaction_date != null">
                  {{ r.credit_log_transaction_date }}
                </td>
                <td v-else>{{ r.created_at }}</td>
                <td style="padding-left:10px; padding-right:10px">
                  <a
                    style="color:#424242"
                    tooltip="View Invoice"
                    @click="initDetail('modal_showAppLog', r.credit_log_transaction_id)"
                  >
                    <i class="material-icons">assignment</i>
                  </a>
                </td>
              </tr>
              <tr style="height: 90px;">
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td
                  style="float: right; text-align: right; font-size: 14px; font-weight: bold; padding-top: 10px"
                >
                  Total Sub:
                  <span style="padding-left: 10px">${{ calculationResults.total_sub }}</span> <br />
                  Total Refund: &nbsp;<span style="padding-left: 10px"
                    >${{ calculationResults.total_refund }}</span
                  >
                  <br />
                  General Total:
                  <span style="padding-left: 10px">${{ calculationResults.total }}</span>
                </td>
              </tr>
              <tr id="no-result-row">
                <td :colspan="columns.length" class="text-center">
                  <v-alert type="error" :value="alertValue">
                    No Results Found
                  </v-alert>
                </td>
              </tr>
            </tbody>
          </datatable>

          <mobile-datatable v-if="isMobile" :isOrder="true">
            <tbody>
              <tr v-for="r in apiResults" :key="r.order_id">
                <td>
                  Invoice No. : {{ r.invoice_number }} , <br />
                  {{ r.product_name }} , <br />
                  <a :href="r.product_url" target="_blank">{{
                    r.product_url.replace(/http(s)?:\/\//, '').substr(0, 25) +
                      (r.product_url.length > 25 ? '...' : '')
                  }}</a>
                </td>
                <td>
                  <span v-if="r.description.includes('Subtract')">-</span>
                  <span v-else>+</span>
                  ${{ r.amount }} <br />
                  <span v-if="r.credit_log_transaction_date != null">
                    {{ r.credit_log_transaction_date }}
                  </span>
                  <span v-else> {{ r.created_at }} </span>
                  <br />
                  <a
                    style="color:#424242"
                    tooltip="View Invoice"
                    @click="initDetail('modal_showAppLog', r.credit_log_transaction_id)"
                  >
                    <i class="material-icons">assignment</i>
                  </a>
                </td>
              </tr>

              <tr>
                <td style="font-size: 14px; font-weight: bold;">
                  Total Sub
                </td>
                <td style="font-size: 14px; font-weight: bold;">
                  ${{ calculationResults.total_sub }}
                </td>
              </tr>
              <tr>
                <td style="font-size: 14px; font-weight: bold">
                  Total Refund
                </td>
                <td style="font-size: 14px; font-weight: bold">
                  ${{ calculationResults.total_refund }}
                </td>
              </tr>
              <tr>
                <td style="font-size: 14px; font-weight: bold;">
                  General Total
                </td>
                <td style="font-size: 14px; font-weight: bold;">${{ calculationResults.total }}</td>
              </tr>
              <tr id="no-result-row">
                <td colspan="2" class="text-center">
                  <v-alert type="error" :value="alertValue">
                    No Results Found
                  </v-alert>
                </td>
              </tr>
            </tbody>
          </mobile-datatable>

          <view-log-details
            :detialData="detialData"
            :closeModal="closeModal"
            :companyData="companyData"
          ></view-log-details>

          <hr />
          <div class="row">
            <div class="col-xs-12 text-right">
              <paginate
                :page-count="pagination.lastPage"
                :page-range="2"
                :changePage="changePage"
                :container-class="'pagination'"
                :pagination="pagination"
                :page-class="'page-item'"
              ></paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationVue from '../Pagination.vue'
import preDatatableComponent from '../preDatatableComponent.vue'
import DatatableVue from '../Datatable.vue'
import viewLogDetails from '../logs/viewLogDetails.vue'
import mobileDatatable from '../mobileDatatable'
import axios from 'axios'
import swal from 'sweetalert'

export default {
  components: {
    preDatatableComponent: preDatatableComponent,
    datatable: DatatableVue,
    paginate: PaginationVue,
    'view-log-details': viewLogDetails,
    'mobile-datatable': mobileDatatable
  },
  created() {
    this.getLoggedInUser()
    this.getResults()
    this.getCalculation()
  },
  mounted() {
    if (!this.loggedInUserData.is_staff) {
      this.getUser()
    }
    this.perPageFix()

    if (screen.width <= 600) {
      this.isMobile = true
    } else {
      this.isMobile = false
    }
  },
  $_veeValidate: {
    validator: 'new'
  },
  data() {
    let sortOrders = {}
    let columns = [
      { label: 'ID', sortable: true, searchable: true, name: 'theOrderID' },
      { label: 'Invoice Number', sortable: true, searchable: true, name: 'invoice_number' },
      { label: 'Product URL', sortable: true, searchable: true, name: 'product_url' },
      { label: 'Product Name', sortable: true, searchable: true, name: 'product_name' },
      { label: 'Amount', sortable: true, searchable: true, name: 'amount' },
      {
        label: 'Invoice Date',
        sortable: true,
        searchable: true,
        name: 'credit_log_transaction_date'
      }
    ]
    columns.forEach(column => {
      sortOrders[column.name] = -1
    })

    return {
      isMobile: false,
      loader: null,
      loading: false,
      url: 'api/customer_invoices',
      logDetailUrl: 'api/credit_log_transactions',
      calculationUrl: 'api/customer_transaction_calculation',
      rowIndex: '',
      companyUrl: 'api/company_info',
      alertValue: false,
      checkAlert: false,
      btnsave: true,
      companyData: {
        company_name: '',
        company_address: '',
        company_email: ''
      },
      loggedInUserData: {},
      detialData: {
        credit_log_transaction_date: '',
        credit_log_transaction_id: '',
        invoice_number: '',
        amount: '',
        money_amount: '',
        created_at: '',
        full_name: '',
        email: '',
        address: '',
        quantity_charge: '',
        phone_number: '',
        product_name: '',
        quantity: '',
        item_price: '',
        tax: '',
        item_weight: '',
        internal_shipping_handling: '',
        kreenex_fee: '',
        delivery_price: '',
        insurance: '',
        description: '',
        refund_reason: ''
      },
      prevSearchQuery: '',
      apiResults: [],
      calculationResults: {},
      detailResults: [],
      columns: columns,
      sortKey: 'credit_log_transaction_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'credit_log_transaction_id',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    }
  },

  methods: {
    getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'))
    },

    getUser() {
      let token = localStorage.getItem('access_token')
      axios.get('api/me', { headers: { Authorization: 'Bearer ' + token } }).then(response => {
        localStorage.setItem('user_data', JSON.stringify(response.data))
      })
    },

    getCalculation(theUrl = this.calculationUrl) {
      let token = localStorage.getItem('access_token')
      axios.get(theUrl, { headers: { Authorization: 'Bearer ' + token } }).then(response => {
        this.calculationResults = response.data.data
      })
    },

    getResults(url = this.url) {
      var token = localStorage.getItem('access_token')
      let theDatatable = document.querySelector('.the-datatable')
      let thePanel = document.querySelector('.panel-flat')

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out')
        thePanel.style.overflowX = 'auto'
      }

      axios
        .get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          let data = response.data
          this.apiResults = data.data.data

          if (this.apiResults.length === 0) {
            this.tableData.searchOneCol = ''
            this.tableData.searchOneVal = ''
            this.tableData.search = ''
            this.alertValue = true
          } else {
            this.alertValue = false
          }
          this.configPagination(data.data)
          theDatatable.classList.remove('slide-table-out')
          setTimeout(function() {
            thePanel.style.overflowX = 'auto'
          }, 0)
        })
        .catch(errors => {})
    },

    resetGetResults() {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'credit_log_transaction_id'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'credit_log_transaction_id'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.getResults()
      this.getCalculation()
    },

    resetGetResults2() {
      this.queryParameter = false
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'credit_log_transaction_id'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'credit_log_transaction_id'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.getResults()
    },

    filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate
      this.tableData.to_date = toDate
      this.getResults()
    },

    perPageFix(perPage) {
      this.tableData.per_page = perPage
      this.getResults()
    },

    modal(modal) {
      $('#' + modal).modal({ backdrop: 'static' })
    },

    closeModal(modal) {
      this.getResults()
      let theModal = $('#' + modal)
      theModal.modal('toggle')
    },

    initDetail(modal, id) {
      let token = localStorage.getItem('access_token')
      this.getCompanyData(token)
      axios
        .get(this.logDetailUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          let data = response.data
          this.detailResults = data.data

          this.detialData = this.detailResults[0]
        })
      this.modal(modal)
    },

    getCompanyData(token) {
      axios
        .get(this.companyUrl, { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          let data = response.data
          let companyResult = []
          companyResult = data.data

          this.companyData.company_name = companyResult.company_name
          this.companyData.company_address = companyResult.company_address
          this.companyData.company_email = companyResult.company_email
        })
    },

    changePage(pageUrl) {
      this.url = pageUrl
      this.getResults()
    },

    searchMe(str) {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      if (str.trim() !== '') {
        this.tableData.search = str
        this.prevSearchQuery = str
        this.getResults()
      } else {
        swal({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        })
        if (this.prevSearchQuery !== '') {
          this.tableData.search = ''
          this.prevSearchQuery = ''
          this.getResults()
        }
      }
    },

    sortByColumn(str) {
      this.tableData.column = str
      this.tableData.sortKey = str
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc'
      this.getResults()
    },

    searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName
      this.tableData.searchOneVal = str
      this.getResults()
    },

    configPagination(data) {
      this.pagination.lastPage = data.last_page
      this.pagination.currentPage = data.current_page
      this.pagination.total = data.total
      this.pagination.lastPageUrl = data.last_page_url
      this.pagination.nextPageUrl = data.next_page_url
      this.pagination.prevPageUrl = data.prev_page_url
      this.pagination.from = data.from
      this.pagination.to = data.to
    }
  }
}
</script>

<style>
.panel-heading {
  color: #006B8D;
  border-bottom: 2px solid #006B8D !important;
}

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

.col-xs-12 {
  padding-top: 10px;
  padding-bottom: 10px;
}

.page-stats {
  align-items: center;
  position: relative;
  top: -8px;
  margin-right: 5px;
}

@media screen and (max-width: 767px) {
  .form-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}

@media screen and (max-width: 600px) {
  th {
    font-weight: bold;
    color: #273246;
    padding-left: 5px !important;
  }

  td {
    padding-left: 5px !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
}

a:hover {
  color: #03a9f4;
  position: relative;
}
a[tooltip]:hover:after {
  content: attr(tooltip);
  padding: 8px 12px;
  color: #ffffff;
  position: absolute;
  right: 80%;
  bottom: 150%;
  white-space: nowrap;
  z-index: 20;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  -moz-box-shadow: 0px 0px 2px #484b4e;
  -webkit-box-shadow: 0px 0px 2px #484b4e;
  box-shadow: 0px 0px 2px #484b4e;
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0, #484b4e),
    color-stop(1, #484b4e)
  );
  background-image: -webkit-linear-gradient(top, #484b4e, #484b4e);
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -ms-linear-gradient(top, #484b4e, #484b4e);
  background-image: -o-linear-gradient(top, #484b4e, #484b4e);
}
</style>



// WEBPACK FOOTER //
// src/components/customer/invoices.vue